import { z } from 'zod';

import { BaseAttribute } from './base-attribute';

export const MarginBottomClass = BaseAttribute.extend({
  marginClass: z.string().nullable().optional(),
});

export type MarginBottomClass = z.infer<typeof MarginBottomClass>;
